import { VisitStatus } from '@precheckin/models/enums/visit-status.enum';
import {
  IVisitDocument,
  VisitDocument
} from '@precheckin/models/visit-document/visit-document.model';

export enum PrecheckinVisitDocumentActions {
  SetIsDocumentReady = '[SetIsDocumentReady] action',
  GetDocuments = '[GetDocuments] action',
  InitializeDocuments = '[InitializeDocuments] action',
  SetPassport = '[SetPassport] action',
  SetPilotLicenses = '[SetPilotLicenses] action',
  SetMedicalCertificates = '[SetMedicalCertificates] action',
  SetVisa = '[SetVisa] action',
  ResetDocuments = '[ResetDocuments] action',
  UpSertDocument = '[UpSertDocument] action',
  DeleteDocument = '[DelegeDocument] action',
  DeletePage = '[DelegePage] action',
  SetAllDocumentsPagesReady = '[SetAllDocumentsPagesReady] action'
}

export class SetIsDocumentReady {
  public static readonly type =
    PrecheckinVisitDocumentActions.SetIsDocumentReady;
  constructor(public isReady: boolean) {}
}

export class GetDocuments {
  public static readonly type = PrecheckinVisitDocumentActions.GetDocuments;
  constructor(public visitId: string) {}
}

export class InitializeDocuments {
  public static readonly type =
    PrecheckinVisitDocumentActions.InitializeDocuments;
  constructor(public documents: IVisitDocument[]) {}
}

export class SetPassport {
  public static readonly type = PrecheckinVisitDocumentActions.SetPassport;
  constructor(public passport: IVisitDocument) {}
}

export class SetPilotLicenses {
  public static readonly type = PrecheckinVisitDocumentActions.SetPilotLicenses;
  constructor(public pilotLicenses: IVisitDocument[]) {}
}

export class SetMedicalCertificates {
  public static readonly type =
    PrecheckinVisitDocumentActions.SetMedicalCertificates;
  constructor(public medicalCertificates: IVisitDocument[]) {}
}

export class SetVisa {
  public static readonly type = PrecheckinVisitDocumentActions.SetVisa;
  constructor(public visa: IVisitDocument) {}
}

export class UpSertDocument {
  public static readonly type = PrecheckinVisitDocumentActions.UpSertDocument;
  constructor(public documents: VisitDocument | VisitDocument[], public visitStatus: VisitStatus) {}
}

export class DeleteDocument {
  public static readonly type = PrecheckinVisitDocumentActions.DeleteDocument;
  constructor(public document: VisitDocument) {}
}

export class DeletePage {
  public static readonly type = PrecheckinVisitDocumentActions.DeletePage;
  constructor(public document: VisitDocument, public blobId: string) {}
}

export class ResetDocuments {
  public static readonly type = PrecheckinVisitDocumentActions.ResetDocuments;
}

export class SetAllDocumentsPagesReady {
  public static readonly type =
    PrecheckinVisitDocumentActions.SetAllDocumentsPagesReady;
}
